var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomePartyingFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 36.9,
    viewBox: "0 0 35 36.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.51,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fde030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f7c02b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4a223"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.607,
    r: 0.577,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ed7770",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 1.423,
    cy: 33.863,
    r: 0.589,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.004,
    y1: -38.996,
    x2: 0.999,
    y2: -38.996,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#45a4ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "partying-face-svgrepo-com",
    transform: "translate(-8.838 -1.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M27.467,55.182C20.03,55.182,12,50.518,12,40.281s8.03-14.9,15.467-14.9a16.224,16.224,0,0,1,10.77,3.837,14.339,14.339,0,0,1,4.691,11.064,14.276,14.276,0,0,1-4.691,11.037A16.3,16.3,0,0,1,27.467,55.182Z",
    transform: "translate(-2.214 -16.582)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M45.122,45.54A15.091,15.091,0,0,1,47.283,53.6a14.29,14.29,0,0,1-4.691,11.037A16.291,16.291,0,0,1,31.822,68.5c-4.814,0-9.871-1.957-12.842-6.115,2.869,4.709,8.261,6.915,13.375,6.915a16.3,16.3,0,0,0,10.77-3.864A14.281,14.281,0,0,0,47.816,54.4,14.864,14.864,0,0,0,45.122,45.54Z",
    transform: "translate(-7.102 -30.699)",
    fill: "#eb8f00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(8.838 1.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 5.246,
    cy: 4.946,
    rx: 5.246,
    ry: 4.946,
    transform: "translate(2.237 16.007)",
    opacity: 0.8,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 5.246,
    cy: 4.946,
    rx: 5.246,
    ry: 4.946,
    transform: "translate(20.342 16.007)",
    opacity: 0.8,
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 2.098,
    cy: 1.499,
    rx: 2.098,
    ry: 1.499,
    transform: "translate(2.447 2.488)",
    fill: "#ff00a2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 1.259,
    cy: 1.649,
    rx: 1.259,
    ry: 1.649,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 10.15, 6.823)",
    fill: "#fd3b3b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 2.518,
    cy: 1.169,
    rx: 2.518,
    ry: 1.169,
    transform: "translate(16.38 5.566) rotate(-37.74)",
    fill: "#0ef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 0.869,
    cy: 1.948,
    rx: 0.869,
    ry: 1.948,
    transform: "translate(2.431 22.721) rotate(-30)",
    fill: "#0048ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 1.049,
    cy: 1.649,
    rx: 1.049,
    ry: 1.649,
    transform: "translate(25.228 30.965)",
    fill: "#f63bbe"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 1.948,
    cy: 0.6,
    rx: 1.948,
    ry: 0.6,
    transform: "matrix(0.818, -0.576, 0.576, 0.818, 29.999, 17.236)",
    fill: "#0c0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 0.749,
    cy: 1.799,
    rx: 0.749,
    ry: 1.799,
    transform: "matrix(0.836, -0.549, 0.549, 0.836, 1.489, 33.175)",
    fill: "#0048ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.799,
    cy: 0.749,
    rx: 1.799,
    ry: 0.749,
    transform: "translate(0 28.546) rotate(-4.052)",
    fill: "#7acded"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 2.158,
    cy: 0.51,
    rx: 2.158,
    ry: 0.51,
    transform: "translate(2.359 25.114) rotate(-3.801)",
    fill: "#ff82b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M93.1,72.633a3.337,3.337,0,0,0-1.679-2.038,2.84,2.84,0,0,0-3.852,1.142c-.006.009-.009.018-.015.027a2.423,2.423,0,0,0,.989,3.267,2.106,2.106,0,0,0,1.529.21,1.82,1.82,0,0,0,1.229-.959,1.939,1.939,0,0,0-.06-1.769,1.551,1.551,0,0,0-1.259-.839.558.558,0,0,0-.09,1.109.434.434,0,0,1,.36.24.963.963,0,0,1,.06.689.734.734,0,0,1-.51.39.985.985,0,0,1-.719-.09,1.308,1.308,0,0,1-.629-.749,1.428,1.428,0,0,1,.09-.989,1.664,1.664,0,0,1,1.019-.839,1.828,1.828,0,0,1,1.319.12,2.324,2.324,0,0,1,1.109,1.379,2.274,2.274,0,0,1-.18,1.769,3.5,3.5,0,0,1-3.3,1.8c-.929,0-6.46-.15-6.46-.15l.066,1.379,6.334-.09A4.607,4.607,0,0,0,92.8,75.21a3.1,3.1,0,0,0,.3-2.578Z",
    transform: "translate(-60.104 -49.701)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M69.958,91.109a2.062,2.062,0,0,1,.42.671l3.432-.021c0-.45-.06-.9-.06-1.379-.9-.03-2.752-.06-3.327-.081a1.726,1.726,0,0,1-.483.809Z",
    transform: "translate(-51.624 -63.742)",
    fill: "#7f0099"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(20.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M94.156,49.338l1.049.15.27-1.049.15-.6L89.6,47C92.328,49.068,93.976,49.338,94.156,49.338Z",
    transform: "translate(-85.613 -33.421)",
    fill: "#ff4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M113.828,5.4,111.4,6.779l-.6.33,2.518.36C113.5,6.719,113.828,5.4,113.828,5.4Z",
    transform: "translate(-100.458 -4.291)",
    fill: "#ff4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M97.188,15.5,94.7,16.909l6.5.929.42-1.709Z",
    transform: "translate(-89.184 -11.363)",
    fill: "#ff4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M79.23,25.889H79.2l10.342,1.5.39-1.589-8.423-1.2Z",
    transform: "translate(-78.331 -17.736)",
    fill: "#ff4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M79.049,35.988l8.633,1.229L88.1,35.6,77.7,34.1A5.958,5.958,0,0,0,79.049,35.988Z",
    transform: "translate(-77.28 -24.388)",
    fill: "#ff4545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M86.9,21.519l8.423,1.2.42-1.589-6.5-.929Z",
    transform: "translate(-83.723 -14.655)",
    fill: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M107.606,12.189s.09-.42.15-.629l-2.518-.36L102.9,12.519l4.436.629.27-.959Z",
    transform: "translate(-94.926 -8.352)",
    fill: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M76.3,29.45l.33.959a.506.506,0,0,0,.06.15l10.4,1.5.39-1.589L77.139,29l-.839.45Z",
    transform: "translate(-76.3 -20.817)",
    fill: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M84.3,42.358c.03.03.09.06.12.09l6.025.869.39-1.589L82.2,40.5A20.939,20.939,0,0,0,84.3,42.358Z",
    transform: "translate(-80.431 -28.869)",
    fill: "#ff9c9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 1.439,
    cy: 1.439,
    r: 1.439,
    transform: "translate(11.9)",
    fill: "#c93737"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M63.884,82.878a2.254,2.254,0,0,0,.77-1.5,2.015,2.015,0,0,0-.48-1.619c-.7-.917-2.641-.689-2.641-.689-.522.021-1.124.27-1.049.869a.98.98,0,0,0,.725.686c.767.183,1.861,0,1.891.779.036.875-1.307.516-1.415,1.442s1.415.8,1.415,1.442c0,.489-.5.573-1.028.683-.453.093-1.322.234-1.391.752s.228,1.157,1.451.971c1.924-.3,2.572-1.346,2.572-1.993A2.344,2.344,0,0,0,63.884,82.878Z",
    transform: "translate(-44.999 -55.861)",
    fill: "#422b0d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(7.668 15.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M39.047,56.985,39,56.928l-.12-.153-.153-.165c-.06-.066-.132-.138-.2-.21a2.568,2.568,0,0,0-.237-.2,1.774,1.774,0,0,0-.237-.153.579.579,0,0,0-.186-.069.2.2,0,0,0-.06,0h-.1a.061.061,0,0,0-.033,0,.579.579,0,0,0-.186.069,1.774,1.774,0,0,0-.237.153c-.078.06-.159.132-.237.2-.147.144-.276.3-.366.393l-.144.171-.066.075a1.2,1.2,0,0,1-1.586.171,1,1,0,0,1-.417-.98s.021-.114.075-.3a3.694,3.694,0,0,1,.354-.821,3.619,3.619,0,0,1,.932-1.1,3.22,3.22,0,0,1,.857-.468,2.016,2.016,0,0,1,.261-.081,2.058,2.058,0,0,1,.3-.066l.174-.024h.665a1.819,1.819,0,0,1,.282.039,3.26,3.26,0,0,1,1.391.611,3.6,3.6,0,0,1,.953,1.085,3.3,3.3,0,0,1,.228.462c.057.132.1.273.135.378a1.2,1.2,0,0,1,.045.207v.069a1.061,1.061,0,0,1-.9,1.2.135.135,0,0,1-.033,0A1.176,1.176,0,0,1,39.047,56.985Z",
    transform: "translate(-34.419 -53.37)",
    fill: "#422b0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M76.215,56.985l-.045-.057-.12-.153-.135-.165c-.06-.066-.132-.138-.2-.21a2.568,2.568,0,0,0-.237-.2,1.773,1.773,0,0,0-.237-.153.589.589,0,0,0-.183-.069.2.2,0,0,0-.06,0h-.147a.589.589,0,0,0-.183.069,1.774,1.774,0,0,0-.237.153,2.569,2.569,0,0,0-.237.2c-.15.144-.276.3-.369.393l-.144.171-.066.075a1.2,1.2,0,0,1-1.586.171,1,1,0,0,1-.417-.98,2.984,2.984,0,0,1,.078-.3,3.652,3.652,0,0,1,.33-.836,3.6,3.6,0,0,1,.953-1.085,3.238,3.238,0,0,1,.86-.468,1.974,1.974,0,0,1,.258-.081,2.058,2.058,0,0,1,.3-.066l.174-.024h.665a1.771,1.771,0,0,1,.282.039,3.257,3.257,0,0,1,1.394.6,3.636,3.636,0,0,1,.953,1.085,3.282,3.282,0,0,1,.225.462,2.831,2.831,0,0,1,.135.378,1.277,1.277,0,0,1,.045.207v.069A1.053,1.053,0,0,1,77.37,57.4c-.012,0-.024,0-.039.006A1.2,1.2,0,0,1,76.215,56.985Z",
    transform: "translate(-60.454 -53.37)",
    fill: "#422b0d"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePartyingFace);
export default __webpack_public_path__ + "static/media/welcome-partying-face.88228cdba90c8b01ee4933af1856a414.svg";
export { ForwardRef as ReactComponent };